import { Component,OnInit, ViewChild} from '@angular/core';
import { ToastService }     from 'ng-uikit-pro-standard';
import { KeycloakService }  from 'keycloak-angular';
import { SharedService } from '../shared/shared.service';
import { AppConstants } from '../config.service';
import { Subscription } from 'rxjs';
import { AuthService } from '../auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public user: any;
  public userEmailAddress: any = {};
  public loggedInUserInitials:string;
  sub: Subscription;
  roleAccessSubscription: Subscription;
  canShowHeader : boolean = false;
  constructor(
    private keycloakService: KeycloakService,
    public toastr: ToastService,
    private sharedService : SharedService,
    private appConstants : AppConstants,
    private authService : AuthService,
    private translate : TranslateService
  ) {

    this.sub = this.authService.checksprigAvailable.subscribe(data => {
      if (data && data.sprigNotAvailable)
        this.showDocWarningModal(data)
    })
    this.userPreferenceCdnUrl =this.appConstants.endPoints.webComponentsEndPoint + 'user-preference-modal/user-preferences-modal.js'
    this.switchAppDropDownCdnUrl = this.appConstants.endPoints.webComponentsEndPoint + 'switch-app-dropdown/js/switch-app-dropdown.js';
    this.notificationCompCdnUrl = this.appConstants.endPoints.webComponentsEndPoint + 'notification-element/notification-component.js';
    this.roleAccessSubscription = this.authService.roleAccessSubscription.subscribe(data => {
      this.canShowHeader = data;
    })
   }

  dropDownSendData : any = {};
  switchAppDropDownCdnUrl : string = "";
  notificationCompCdnUrl: string = "";
  userPreferenceCdnUrl : string = "";
  async ngOnInit() {
    if (await this.keycloakService.isLoggedIn()) {
      this.appConstants.checkAuth();
      const user = this.appConstants.userDetails
      this.userEmailAddress = user.email
      this.user = user.firstName + ' ' + user.lastName
      this.loggedInUserInitials = this.user.match(/\b(\w)/g).join('');
      this.notificationCount();
      await this.appConstants.getTenantId();
      this.dropDownSendData = {
        url : this.appConstants.endPoints.tenantEndPoint + this.appConstants.tenantId + '/users/' + user.email + '/applications', 
        params:{} ,
        imageBasePath : this.appConstants.endPoints.webComponentsEndPoint + 'switch-app-dropdown/images/app-icons/'                              
    }

      setInterval(() => {
        this.getToken();
      }, 1000);
      this.setUserPreferenceModalData()
      let selectionInterval = setInterval(()=>{
        this.notificationCount();
      },this.appConstants.endPoints.notificationCountInterval)
    }
  }

  sendToken: any = {};
  async getToken() {
    let token
    if (await this.keycloakService.isLoggedIn()) {
      token = await this.keycloakService.getToken();
      this.sendToken = Object.assign({}, {
        token: token
      })
    }
  }

  public msgCount: number;
  notificationCount() {
    this.sharedService.get(this.appConstants.endPoints.notificationEndPoint + 'unread-count', {destinationAddress: this.userEmailAddress})
      .subscribe(data => {
        this.msgCount = data
      }, error => {

      });

  }

  async logout() {
    const localStorgeAttributes = [
      "isSprigEnabled",
      "selectedDevice"
    ];
    for (let index = 0; index < localStorgeAttributes.length; index++) {
      const element = localStorgeAttributes[index];
      localStorage.removeItem(element);
    }
    await this.keycloakService.logout();
  }

  notificationInfo:any={};
  isDrawerOpen = false;

  async toggleShowDrawer() {
    this.isDrawerOpen = !this.isDrawerOpen;
    let notificationsData;
    if (this.isDrawerOpen) {
      const token = await this.keycloakService.getToken();
      notificationsData = {
        headers: {
          token: token,
          customerId: "",
        },
        unread: {
          url: this.appConstants.endPoints.notificationEndPoint + 'unread',
          params: { destinationAddress: this.userEmailAddress }
        },
        markAsRead: {
          url: this.appConstants.endPoints.notificationEndPoint + 'mark-as-read',
          params: { destinationAddress: this.userEmailAddress }
        },
        markAllRead: {
          url: this.appConstants.endPoints.notificationEndPoint + 'mark-all-read',
          params: { destinationAddress: this.userEmailAddress }
        }
      }
      notificationsData['isOpen'] = this.isDrawerOpen;
      this.notificationInfo = { ...{}, ...notificationsData };
    }
    else {
      this.notificationInfo = { isOpen: false };
    }
  }
  closeNotification(e){
      this.isDrawerOpen=false;   
  }

  setNotificationBadge(e){
    this.msgCount = e
  }

  sprigWarningData: any = {}
  showDocWarningModal(obj) {
    this.sprigWarningData = { ...{}, ...obj }
  }

 
  endpoints: any = {}
  async setUserPreferenceModalData() {
    let token = await this.keycloakService.getToken();
    this.sendToken = Object.assign({}, {
      token: token
    })
    let endpoint = {
      appliances: this.appConstants.endPoints.sprigApiEndPoint + 'admin/',
      sprigEndPoints: this.appConstants.endPoints.sprigApiEndPoint,
    }
    this.endpoints = { ...{}, ...endpoint }  
  }

  openUserPreferencesModal(){
    //TODO:
    this.open()
  }

  userPreferencesData: any = {};
  async open() {
    const user = this.appConstants.userDetails;
    const token = await this.keycloakService.getToken();
    this.sendToken = {
      token: token
    };

    setInterval(() => {
      this.getToken();
    }, 1000);
    let endpoint = {
      schedulesEndpoint: this.appConstants.endPoints.schedulesEndpoint,
      samplesEndpoint: this.appConstants.endPoints.sampleTrackerEndpoint,
      tenantEndPoint: this.appConstants.endPoints.tenantEndPoint,
      messageNotificationEndPoint: this.appConstants.endPoints.notificationEndPoint,
      reportServicesEndPoint: this.appConstants.endPoints.reportServicesEndPoint,
      appliances: this.appConstants.endPoints.sprigApiEndPoint + 'admin/',
      sprigEndPoints: this.appConstants.endPoints.sprigApiEndPoint,
      resourcesEndPoint: this.appConstants.endPoints.resourcesEndPoint
    }
    let obj = {}
    obj['userInfo'] = this.appConstants.userDetails
    obj['endPoints'] = endpoint
    obj['showModal'] = true
    this.userPreferencesData = { ...{}, ...obj }
  }

  langChanged(lang) {
    if (lang && lang.detail)
      this.translate.use(lang.detail).subscribe(res => { },
        err => {
          this.toastr.warning(this.translate.instant('administration_langNotSupported_label'));
          this.translate.use('en');
          const userSettings = { preferredLanguageCode: 'en' };
          localStorage.setItem("userSettingsJson", JSON.stringify(userSettings));
        })
  }

  toastMessages(message) {
    if (message && message.detail) {
      let toastMessage = message.detail
      if (toastMessage && toastMessage.success)
        this.toastr.success(toastMessage.success)
      else 
        this.toastr.success(toastMessage.error.errorMessage)
    }
  }

  defaultSprigInfo: any = {}
  getSprigInfo(event) {
    if (event && event.detail) {
      this.defaultSprigInfo = { ...{}, ...event.detail }
    }
  }
}
